/* eslint-disable camelcase, import/prefer-default-export */
import { AxiosResponse } from 'axios';

export const API = 'permission/role/lists';

type p5_role_id = string //  角色GUID
type p3_bre_status = '3' | '-2' //  狀態:3.啟用 -2.停用
type p3_bre_sort = number //  排序
type p5_role_name = string //  名稱
type p3_bre_specific = string //  類型:請忽略此項目
type p3_bre_p3_bch_id = number //  所屬站台ID
type p3_bre_memo = string // 備註
type search_complex = string // 合併(名稱、域名、代碼)
type search_p3_bre_status = '3' | '-2' // 狀態 3.正常 -2.停用
type search_p5_role_name = string // 名稱
type sort = 'p3_bre_sort' | 'p5_role_name' | 'p3_bre_status' // 排序欄位 排序 名稱 狀態
type sort_type = 'DESC' | 'ASC' // 降序 升序

/**
 * @property search_complex 關鍵字
 * @property search_p5_role_name 名稱
 * @property search_p3_bre_status 3.正常 -2.停用
 * @property sort 排序欄位 p3_bre_sort:排序, p5_role_name:名稱, p3_bre_status:狀態
 * @property sort_type 降序:DESC 升序:ASC
 * @property page 頁數
 * @property perpage 一頁幾筆
 */
export interface request {
    search_complex?: search_complex,
    search_p5_role_name?: search_p5_role_name,
    search_p3_bre_status?: search_p3_bre_status,
    sort?: sort,
    sort_type?: sort_type,
    page?: number,
    perpage?: number,
}

export interface AxiosResponse extends AxiosResponse<responseExtends> { }

interface responseExtends extends backendResponse {
  response: response
}

export type response = {
  list: listItem[],
  paginator: pageinator
}

export type listItem = {
  p5_role_id?: p5_role_id,
  p3_bre_status?: p3_bre_status,
  p3_bre_sort?: p3_bre_sort,
  p5_role_name?: p5_role_name,
  p3_bre_specific?: p3_bre_specific,
  p3_bre_p3_bch_id?: p3_bre_p3_bch_id,
  p3_bre_memo?: p3_bre_memo,
  p3_bre_name?:string
}
